import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Observable, Subject } from 'rxjs';

import { SessionStoreService } from '../../../services/session-store.service';
import { TemplateService } from '../../../services/template.service';
import { layoutChangeAnim } from '../../../shared/animations/layout-animation';
import { sidenavAnim } from '../../../shared/animations/sidenav-animation';
import { DynamicAnimation } from '../../../shared/animations/sidepane-animation';
import { takeUntil } from 'rxjs/operators';
import { Select } from '@ngxs/store';
import { ChatbotState } from '../../../shared/chatbot/state/chatbot.state';
import { BuildInfoService } from '../../../services/build-info.service';
import { Environment } from '../../../services/environment.service';

@Component({
  selector: 'hf-dashboard-template',
  templateUrl: './dashboard-template.component.html',
  styleUrls: ['./dashboard-template.component.scss'],
  animations: [sidenavAnim, layoutChangeAnim]
})
export class DashboardTemplateComponent implements OnInit, OnDestroy, AfterViewInit {
  public templateRoutes;
  public isVisible = true;

  showSidenav: Observable<boolean>;
  stateResult: DynamicAnimation = { value: 'hidden', params: { pos: 0 } };
  @Select(ChatbotState.canShowChatbot) canShowChatbot$!: Observable<boolean>;

  @ViewChild('dynamicSidepanesAnchor', { read: ViewContainerRef })
  root: ViewContainerRef;

  public version$ = this.buildInfoService.version$;
  public isProd = this.environment.production;

  private unsubscribe$ = new Subject();

  constructor(
    public templateService: TemplateService,
    public environment: Environment,
    private router: Router,
    private route: ActivatedRoute,
    private sessionStoreService: SessionStoreService, // keep global instance for app lifecycle
    private buildInfoService: BuildInfoService
  ) {}

  ngAfterViewInit() {
    this.templateService.rootRef = this.root;
  }

  ngOnInit() {
    this.templateRoutes = this.route;
    this.router.events.pipe(takeUntil(this.unsubscribe$)).subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.templateService.closeSidebar();
      }
    });
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.sessionStoreService.clear();
  }
}
